import { Badge, Button, Checkbox, Form, Input, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Axios from 'axios';
import * as Hangul from 'hangul-js';
import React from 'react';
import { withAlert } from 'react-alert';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import {
  addOrderInfo,
  addWaitingOrder,
  removePosOrder,
  removeWaitingOrder,
  removeWaitingOrderByOrderAwaitId,
  updateWaitingOrder,
  removeOrderInfoAll,
} from '../actions/posAction';
import {
  calcShippingDataAsync,
  createOrderAsync,
  createOrderAwaitAsync,
  createOrderAwaitAtCloudFlareWorker,
  createOrderInfoAtCloudFlareWorker,
  deleteOrderAwaitAsync,
  deleteOrderAwaitAtCloudFlareWorker,
  editOrderAwaitAtCloudFlareWorker, getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker,
  getOrderAwaitByIdAtCloudFlareWorker,
  getOrderInfoDetailFromCloudFlareWorker,
  getOrderInfoListFromCloudFlareWorker,
  updateOrderAwaitAsync,
} from '../api/api';
import { httpGet, httpPost, httpUrl } from '../api/httpClient';
import AddressModal from '../components/modal/AddressModal';
import KeyInputModal from '../components/modal/KeyInputModal';
import MapModal from '../components/modal/MapModal';
import PaymentDialog from '../components/modal/PaymentDialog';
import PhoneInputModal from '../components/modal/PhoneInputModal';
import PosOrderModal from '../components/modal/PosOrderModal';
import PriceInputModal from '../components/modal/PriceInputModal';
import WaitingOrderModal from '../components/modal/WaitingOrderModal';
import Const from '../const';
import { getUseNotifyOrderEtc } from '../lib/module';
import {
  branchAddressSearchKeyword,
  defaultConst,
  packAmountCodeString,
  paymentMethodCode,
  paymentMethodString,
  pickupTimeCode,
  pickupTimeValue,
  modalStyle,
  modalErrorStyle,
} from '../lib/util/codeUtil';
import {
  calcPriceOfOrderPayments,
  checkOverPrice,
  comma,
  formatKm,
} from '../lib/util/numberUtil';
import {
  updateFrom,
  updateManualPickupTimeSetup,
  // updatePickupDelay,
} from '../actions/pickupTimeAction';
import Event from './etc/Event';
import image from '../res/image';
import color from '../res/color';

const pageSize = 20;
const regExpPhone =
  /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,5}-?[0-9]{4}$/;

const FormItem = Form.Item;

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,

      selectOpen: false,
      paymentOpen: false,

      orderIdx: 0,
      orderDate: '',
      orderCode: null,
      isBaeminOrder: false,
      waiting: false,
      destAddr1: '',
      destAddr2: '',
      destAddr3: '',
      itemPrepared: false,
      packAmount: 1,
      dist: 0,
      deliveryBasicPrice: 0,
      deliveryAddPrice: 0,
      paymentMethod: defaultConst.paymentMethod,
      pickupTimeIndex: defaultConst.pickupTime,
      refPickupTimeIndex: defaultConst.pickupTime,
      orderPayments: [],
      frLat: this.props.loginReducer.loginInfo.latitude,
      frLng: this.props.loginReducer.loginInfo.longitude,
      targetLat: 0,
      targetLng: 0,

      addrModalOpen: false,
      searchAddressOpen: false,
      mapModalOpen: false,
      phoneInputModalOpen: false,
      priceInputModalOpen: false,
      keyInputModalOpen: false,
      keyInputModal2Open: false,
      waitingOrderModalOpen: false,
      posOrderModalOpen: false,

      overPriceSetting: 100000,
      overPrice: false,
      orderCount: 0,

      deliveryData: {
        deliveryEnabled: true,
      },
      addrBranchData: {
        deliveryStart: true,
      },
      totalAddrBranchData: null,
      addrDeliveryData: {
        deliveryStart: true,
      },

      initializePickupTimeCnt: false,

      tableData: [],
      tableDataEnd: false,
      branchName: '',
      getJibunAddr: false,
    };
    this.formRef = React.createRef();
    this.orderInfos = [];
    this.cloudFlareOrderInfo = [];
  }

  async componentDidMount() {
    this.props.setMain(this);
    if (this.props.location.state) {
      /* TODO ojoomi d1 정식서비스 후 주석해제
          // cloudflare worker에 있는 대기주문 한건만 상세 조회(수정하려는 대기주문)
      const res = await getOrderAwaitByIdAtCloudFlareWorker(this.props.location.state.id);
      const clfOrderAwait = res?.data?.orderAwait;
      if (res.status !== 200) {
        console.error("대기주문 상세 조회 에러");
      }
      let orderAwait = {};
      if (res.status !== 200 || res === 'EXCEPTION' || (clfOrderAwait.constructor === Object && Object.keys(clfOrderAwait).length === 0)) {
        orderAwait = this.props.location.state;
      } else {
        orderAwait = clfOrderAwait;
      }*/

      let orderAwait = this.props.location.state;
      setTimeout(() => {
        this.updateCallData(orderAwait);
      }, 500);

      /*setTimeout(() => {
        this.updateCallData(this.props.location.state);
      }, 500);*/
    }
    this.updateDeliveryData();
    // this.setDefaultPickupTime();
    this.pollingDeliveryData = setInterval(() => {
      this.updateDeliveryData();
    }, 5000);

    this.updateAddrBranchData();
    this.pollingAddrBranchData = setInterval(() => {
      this.updateAddrBranchData();
    }, 5000);
    this.getBranchInfo();

    const self = this;
    setTimeout(() => {
      if (this.props.location.state && this.props.location.state.cidNum) {
        this.formRef.current.setFieldsValue({
          custPhone: this.props.location.state.cidNum,
        });
        self.handleInquiryOrder(this.props.location.state.cidNum);
      }
    }, 500);

    await this.loadOrderInfo();
  }

  componentWillUnmount() {
    const { basicPickupTime } = this.props.pickupTimeReducer.pickupTimeInfo;

    clearInterval(this.pollingDeliveryData);
    clearInterval(this.pollingAddrBranchData);
    this.props.updateManualPickupTimeSetup(false);
    // const prevPickupTimeIdx = reactLocalStorage.getObject(
    //   Const.appName + '#prevPickupTime'
    // );
    // const pickupTimeDeducted =
    //   pickupTimeValue[prevPickupTimeIdx] - basicPickupTime;
    // this.props.updatePickupDelay(pickupTimeDeducted);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { pickupTimeReducer } = this.props;
    const {
      basicPickupTime,
      delayPickupTime,
      updateFromServer,
      manualPickupTimeSetup,
    } = pickupTimeReducer.pickupTimeInfo;

    if (
      prevProps.pickupTimeReducer.pickupTimeInfo.delayPickupTime !==
        delayPickupTime ||
      prevProps.pickupTimeReducer.pickupTimeInfo.basicPickupTime !==
        basicPickupTime ||
      prevProps.pickupTimeReducer.pickupTimeInfo.manualPickupTimeSetup !==
        manualPickupTimeSetup
    ) {
      const refPickupTimeIdx = reactLocalStorage.getObject(
        Const.appName + '#refPickupTime'
      );

      const pickUpTime = delayPickupTime + basicPickupTime;

      const pickUpTimeIdx = this.calculatePickupTimeIdx(
        refPickupTimeIdx,
        pickUpTime
      );
      if (updateFromServer) {
        this.setState({
          pickupTimeIndex: pickUpTimeIdx,
          // frBasicPickupTime: basicPickupTime,
        });
        this.props.updateFrom(false);
        this.props.updateManualPickupTimeSetup(false);
      }

      if (!manualPickupTimeSetup) {
        if (pickUpTimeIdx !== -1) {
          this.setState({
            pickupTimeIndex: pickUpTimeIdx,
            // frBasicPickupTime: basicPickupTime,
          });
        }
      } else {
      }
    }

    if (
      (prevProps.pickupTimeReducer.pickupTimeInfo.manualPickupTimeSetup !==
        manualPickupTimeSetup ||
        prevProps.pickupTimeReducer.pickupTimeInfo.updateFromServer !==
          updateFromServer) &&
      updateFromServer
    ) {
      const refPickupTimeIdx = reactLocalStorage.getObject(
        Const.appName + '#refPickupTime'
      );
      const pickUpTime = delayPickupTime + basicPickupTime;

      const pickUpTimeIdx = this.calculatePickupTimeIdx(
        refPickupTimeIdx,
        pickUpTime
      );

      if (!manualPickupTimeSetup) {
        this.setState({
          pickupTimeIndex: pickUpTimeIdx,
          // frBasicPickupTime: basicPickupTime,
        });
      }
    }
  }

  updateDeliveryData = () => {
    this.setState(
      {
        deliveryData: reactLocalStorage.getObject(
          Const.appName + '#deliverydata'
        ),
      },
      () => {
        this.initializePickupTime();
      }
    );
  };

  // 배송가능지역 정보
  updateAddrBranchData = () => {
    this.setState({
      addrBranchData: reactLocalStorage.getObject(
        Const.appName + '#addrBranch'
      ),
      totalAddrBranchData: reactLocalStorage.getObject(
        Const.appName + '#totalAddrBranch'
      ),
      addrDeliveryData: reactLocalStorage.getObject(
        Const.appName + '#addrDelivery'
      ),
      // frBasicPickupTime: reactLocalStorage.getObject(
      //   Const.appName + '#basicPickupTime'
      // ),
    });
  };

  updateCallData = (data) => {
    const { delayPickupTime, basicPickupTime } =
      this.props.pickupTimeReducer.pickupTimeInfo;

    this.formRef.current.setFieldsValue({
      custPhone: data.custPhone,
      destAddr1: data.destAddr1,
      destAddr2: typeof data.destAddr2 === 'undefined' ? '' : data.destAddr2,
      destAddr3: typeof data.destAddr3 === 'undefined' ? '' : data.destAddr3,
      custMessage:
        typeof data.custMessage === 'undefined' ? '' : data.custMessage,
      orderPrice: comma(data.orderPrice),
    });

    let orderInfo = this.props.posReducer.orderInfos.find(
      (x) => x.metadata.id === data.custPhone
    );
    const totalDelayTime = delayPickupTime + basicPickupTime;

    let pickupTimeIdx;
    if (typeof data.arriveReqTime !== 'undefined') {
      const pickupTime =
        totalDelayTime > data.arriveReqTime
          ? totalDelayTime
          : data.arriveReqTime;
      pickupTimeIdx = pickupTimeValue.indexOf(pickupTime);
    } else {
      const refPickupTimeIdx = reactLocalStorage.getObject(
        Const.appName + '#refPickupTime'
      );

      pickupTimeIdx = this.calculatePickupTimeIdx(
        refPickupTimeIdx,
        totalDelayTime
      );
    }

    this.setState(
      {
        orderIdx: data.idx,
        orderDate: data.orderDate,
        orderCode: data.orderCode ? data.orderCode : null,
        bmOrderCode: data.orderCode ? data.orderCode : null,
        isBaeminOrder: !data.isBaeminOrder ? false : data.isBaeminOrder,
        waiting: data.waiting ? data.waiting : false,
        paymentMethod:
          typeof data.paymentMethod === 'undefined'
            ? data.orderPayments && data.orderPayments.length > 0
              ? data.orderPayments[0].paymentMethod
              : defaultConst.paymentMethod
            : data.paymentMethod,

        orderPayments:
          typeof data.orderPayments === 'undefined' ? [] : data.orderPayments,
        itemPrepared:
          typeof data.itemPrepared === 'undefined' ? 0 : data.itemPrepared,
        packAmount:
          typeof data.packAmount === 'undefined' ? 1 : data.packAmount,
        pickupTimeIndex: pickupTimeIdx,
        orderCount: data.orderCount,
        id: data.id ? data.id : null,
      },
      () => {
      }
    );

    calcShippingDataAsync(data.destAddr1, data.destAddr3).then((data) => {
      if (data !== null) {
        this.setState({
          targetLat: data.lat,
          targetLng: data.lng,
          dist: data.dist,
          deliveryBasicPrice: data.deliveryBasicPrice,
          deliveryAddPrice: data.deliveryAddPrice,
        });
      }
    });
  };

  openPaymentModal = () => {
    this.setState({ paymentOpen: true });
  };
  closePaymentModal = () => {
    this.setState({ paymentOpen: false });
  };
  openAddrModal = () => {
    this.setState({ addrModalOpen: true });
  };
  closeAddrModal = () => {
    this.setState({ addrModalOpen: false });
  };
  openMapModal = () => {
    this.setState({
      destAddr1: this.formRef.current.getFieldValue('destAddr1'),
      destAddr2: this.formRef.current.getFieldValue('destAddr2'),
      mapModalOpen: true,
    });
  };
  closeMapModal = () => {
    this.setState({ mapModalOpen: false });
  };
  openPhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: true });
  };
  closePhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: false });
  };
  openPriceInputModal = () => {
    this.setState({ priceInputModalOpen: true });
  };
  closePriceInputModal = () => {
    this.setState({ priceInputModalOpen: false });
  };
  openKeyInputModal = () => {
    this.setState({ keyInputModalOpen: true });
  };
  closeKeyInputModal = () => {
    this.setState({ keyInputModalOpen: false });
  };
  openKeyInputModal2 = () => {
    this.setState({ keyInputModal2Open: true });
  };
  closeKeyInputModal2 = () => {
    this.setState({ keyInputModal2Open: false });
  };
  openKeyInputModal3 = () => {
    this.setState({ keyInputModal3Open: true });
  };
  closeKeyInputModal3 = () => {
    this.setState({ keyInputModal3Open: false });
  };

  setAddress = (address) => {
    this.formRef.current.setFieldsValue({
      destAddr3: address.jibunAddr,
      destAddr1: address.roadAddr,
    });
    this.setState({
      destAddr3: address.jibunAddr,
      addrModalOpen: false,
      tableData: [],
      searchAddressOpen: false,
    });

    calcShippingDataAsync(address.roadAddr, address.jibunAddr).then((data) => {
      if (data !== null) {
        this.setState({
          targetLat: data.lat,
          targetLng: data.lng,
          dist: data.dist,
          deliveryBasicPrice: data.deliveryBasicPrice,
          deliveryAddPrice: data.deliveryAddPrice,
        });
      } else {
        this.setState({
          targetLat: 0,
          targetLng: 0,
          dist: 0,
          deliveryBasicPrice: 0,
          deliveryAddPrice: 0,
        });
      }
    });
  };

  onUpdateOverPrice = () => {
    const overPrice = checkOverPrice(
      this.formRef.current.getFieldValue('orderPrice'),
      this.state.overPrice,
      this.state.overPriceSetting
    );

    this.setState({ overPrice });
  };
  onCheckAndUpdatePaymentMethod = (paymentMethod) => {
    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      this.state.orderPayments.length > 1 &&
      paymentMethod !== paymentMethodCode.installment
    ) {
      const self = this;
      Modal.confirm({
        ...modalStyle,
        content: '분할 결제정보가 초기화 됩니다. 결제수단을 변경 하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        onOk() {
          self.setState({
            paymentMethod,
            orderPayments: [],
          });
        },
        onCancel() {},
      });
    } else {
      this.setState({ paymentMethod });
      if (paymentMethod === paymentMethodCode.installment) {
        this.openPaymentModal();
      }
    }
  };
  handlePaymentChange = (data) => {

    let orderPrice = 0;
    let result = 'SUCCESS';
    do {
      if (
        typeof data === 'undefined' ||
        !Array.isArray(data) ||
        data.length < 1
      ) {
        result = 'INVALID_TYPE';
        break;
      }
      for (let i = 0; i < data.length; ++i) {
        if (data[i].paymentAmount === 0) {
          result = 'INVALID_PRICE';
          break;
        }
      }
      if (result !== 'SUCCESS') break;
      orderPrice = calcPriceOfOrderPayments(data);
      if (orderPrice <= 0) {
        result = 'INVALID_PRICE';
        break;
      }
    } while (false);

    // early return
    if (result !== 'SUCCESS') {
      Modal.error({
        title: '분할결제 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (data.length === 1) {
      const self = this;
      const paymentMethod = data[0].paymentMethod;
      Modal.info({
        title: '분할결제 알림',
        content: (
          <div>
            {comma(orderPrice)}원 '{paymentMethodString[paymentMethod]}'결제 한
            건이 등록되어 결제수단이 '{paymentMethodString[paymentMethod]}
            '결제로 전환됩니다.
          </div>
        ),
        ...modalStyle,
        onOk() {
          self.setState({ paymentMethod });
          self.setState({ orderPayments: [] });
        },
      });
    } else {
      this.setState({ orderPayments: data });
    }

    this.formRef.current.setFieldsValue({ orderPrice: comma(orderPrice) });
  };
  handleSubmit = async () => {
    updateManualPickupTimeSetup(false);
    const form = this.formRef.current;
    const orderPrice = parseInt(
      (form.getFieldValue('orderPrice') + '').replace(/,/g, '')
    );
    const custPhone = form.getFieldValue('custPhone')
      ? form.getFieldValue('custPhone').replace(/-/g, '')
      : '0';
    const destAddr1 = form.getFieldValue('destAddr1');
    const destAddr2 = form.getFieldValue('destAddr2');
    const destAddr3 = form.getFieldValue('destAddr3');
    const custMessage = form.getFieldValue('custMessage');

    if (isNaN(orderPrice)) {
      Modal.info({
        title: '주문금액 오류',
        content: '주문금액을 다시 한번 확인해주세요.',
        ...modalStyle,
      });
      return;
    }

    /* backend에서 배송불가 예외상점인지 검증하기 때문에 api 쏘기전에 deliveryEnabled 검사하는 부분 주석
    if (this.state.deliveryData && !this.state.deliveryData.deliveryEnabled) {
      Modal.info({
        title: '배달불가',
        content: '현재 배달불가 상태입니다.',
      });
      return;
    }*/

    if (!this.isEnablePickupTime(this.state.pickupTimeIndex)) {
      Modal.error({
        title: '요청시간 오류',
        content: <div>가능한 픽업요청시간을 선택해주세요.</div>,
        ...modalErrorStyle,
      });
      return;
    }
    /* backend에서 배송불가 예외상점인지 검증하기 때문에 api 쏘기전에 deliveryEnabled 검사하는 부분 주석
    if (this.state.deliveryData && !this.state.deliveryData.deliveryEnabled) {
      this.props.alert.show(
        '현재 배달정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'
      );
      return;
    }*/
    // else if (
    //   this.state.addrBranchData &&
    //   !this.state.addrBranchData.deliveryStart
    // ) {
    //   this.props.alert.show(
    //     '현재 지점배달 제한 상태로 잠시 후 다시 시도해주세요.'
    //   );
    //   return;
    // }
    else if (
      'number' !== typeof this.state.deliveryBasicPrice ||
      'number' !== typeof this.state.deliveryAddPrice ||
      Number(this.state.deliveryBasicPrice) +
        Number(this.state.deliveryAddPrice) <=
        0
    ) {
      // else if (this.state.dist === null || this.state.dist === 0) {
      this.props.alert.show(
        '배송비 계산에 오류가 발생했습니다. 도착지를 다시 선택해주세요.'
      );
      return;
    }
    // if (this.state.deliveryBasicPrice <= 0) {
    //   Modal.error({
    //     title: "접수요청 오류",
    //     content: <div>도착지를 다시 선택해주세요</div>,
    //   });
    //   return;
    // }
    // if (orderPrice === 0) {
    //   Modal.error({
    //     title: "접수요청 오류",
    //     content: <div>주문금액이 올바르지 않습니다. 다시 시도해 주십시오.</div>,
    //   });
    //   return;
    // }
    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      orderPrice !== calcPriceOfOrderPayments(this.state.orderPayments)
    ) {
      Modal.error({
        title: '접수요청 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }
    // if (custPhone == "") {
    //   Modal.error({
    //     title: "전화번호 오류",
    //     content: (
    //       <div>
    //         유효하지 않는 전화번호입니다. 전화번호를 올바르게 입력해주세요.
    //       </div>
    //     ),
    //   });
    //   return;
    // }

    const { TextArea } = Input;
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();

    const orderPayments =
      this.state.paymentMethod === paymentMethodCode.installment
        ? this.state.orderPayments
        : [
            {
              paymentMethod: this.state.paymentMethod,
              paymentAmount: orderPrice,
              paymentStatus: 1,
            },
          ];

    const result = await createOrderAsync({
      latitude: this.state.targetLat,
      longitude: this.state.targetLng,
      orderPayments: orderPayments,
      destAddr1,
      destAddr2,
      destAddr3,
      custMessage,
      itemPrepared: this.state.itemPrepared,
      packAmount: this.state.packAmount,
      basicDeliveryPrice: this.state.deliveryBasicPrice,
      extraDeliveryPrice: this.state.deliveryAddPrice,
      deliveryPrice:
        this.state.deliveryBasicPrice + this.state.deliveryAddPrice,
      arriveReqTime: pickupTimeValue[this.state.pickupTimeIndex],
      ncashPayEnabled: true,
      orderPrice,
      custPhone,
      bmOrderCode:
        !this.state.isBaeminOrder || this.state.orderCode === ''
          ? null
          : this.state.orderCode,
    });

    if (result === 'DELIVERY_NOT_ENABLED') return;
    if (result === 'SUCCESS') {
      if (custPhone.length >= 7) {
        const prevOrderInfo = this.orderInfos.find((x) => x.id === custPhone);
        // 하나 찾아서 지우지 말고 전체 리스트 필터링
        const filteredList = this.orderInfos.filter((x) => x.id !== custPhone);
        this.orderInfos = filteredList;
        reactLocalStorage.setObject(Const.appName + '#orderInfo', filteredList);

        const orderInfo = this.cloudFlareOrderInfo.find(
          (x) => x.metadata && x.metadata.id === custPhone
        );
        let orderCount = 1;
        if (orderInfo) {
          const orderDetail = await getOrderInfoDetailFromCloudFlareWorker(
            custPhone
          );
          orderCount =
            orderDetail && orderDetail.orderCount
              ? orderDetail.orderCount + 1
              : 1;
        }
        if (prevOrderInfo) {
          orderCount =
              prevOrderInfo && prevOrderInfo.orderCount
                  ? prevOrderInfo.orderCount + 1
                  : 1;
        }

        try {
          const res = await createOrderInfoAtCloudFlareWorker({
            id: custPhone,
            custPhone,
            destAddr1,
            destAddr2,
            destAddr3,
            custMessage,
            orderCount,
          });
          if (!orderInfo && res.data.result === 'success') {
            const list = await getOrderInfoListFromCloudFlareWorker();

            this.cloudFlareOrderInfo = list;
          }
          if (res.data.result === 'INVALID_USER_INFO') {
            Modal.warn({
              title: '주문정보 저장 실패',
              content: '주문정보 저장에 실패했습니다. 다시 로그인해주세요.',
              ...modalStyle,
            });
          }
        } catch (e) {}
      }
      if (this.state.orderIdx > 0) {
        if (this.state.waiting) {
          this.props.removeWaitingOrder(this.state.orderIdx);
        } else {
          this.props.removePosOrder(this.state.orderIdx);
        }
      }
      if (this.state.id) {
        deleteOrderAwaitAsync({ id: this.state.id }); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
        /*deleteOrderAwaitAtCloudFlareWorker({ id: this.state.id });*/
        this.props.removeWaitingOrderByOrderAwaitId(this.state.id);
      }

      // 지연시간 해제 상태에서 주문 접수 성공시 #refPickupTime(지연 없을때의 통상 픽업시간)을 업데이트
      if (this.state.deliveryData.delayPickupTime === 0) {
        reactLocalStorage.setObject(
          Const.appName + '#refPickupTime',
          this.state.pickupTimeIndex
        );
      }

      this.props.alert.show('배달요청이 성공적으로 접수되었습니다!!');
      this.formRef.current.resetFields();
      this.props.history.push('/delivery');
    } else if (result === 'BRANCH_CLOSED') {
      let message = '지점 영업시간이 아닙니다. 지점 관리자에게 문의하세요.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else if (result === 'INVALID_USER_STATUS') {
      let message = '유효하지 않은 사용자입니다.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else if (result === 'DELIVERY_START_DISABLED_AREA') {
      let message = '배달요청이 허용되지 않는 지역의 가맹점입니다.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else if (result === 'DELIVERY_END_DISABLED_AREA') {
      let message = '배달요청이 허용되지 않는 주소입니다.';
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    } else {
      let message =
        '시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시 시도해주세요.';
      if (
        result === 'NOT_ENOUGH_NCASH' ||
        result === 'NCASH_AUTO_CHARGE_FAIL'
      ) {
        message = '예치금이 부족합니다. 예치금 충전 후 다시 시도해주세요.';
        if (useEtcVoiceGuidance) {
          let audio = new Audio('11.wav');
          audio.volume = this.props.posReducer.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }
      }
      Modal.error({
        title: '배달요청 실패',
        content: <div>{message}</div>,
        ...modalErrorStyle,
        onOk() {},
      });
    }
  };
  // handleOrderAwait = async () => {
  //   const form = this.formRef.current;
  //   const orderPrice = parseInt(
  //     (form.getFieldValue("orderPrice") + "").replace(/,/g, "")
  //   );
  //   const custPhone = form.getFieldValue("custPhone")
  //     ? form.getFieldValue("custPhone").replace(/-/g, "")
  //     : "0";
  //   const destAddr1 = form.getFieldValue("destAddr1");
  //   const destAddr2 = form.getFieldValue("destAddr2");
  //   const destAddr3 = form.getFieldValue("destAddr3");

  //   if (!this.isEnablePickupTime(this.state.pickupTime)) {
  //     Modal.error({
  //       title: "요청시간 오류",
  //       content: <div>가능한 픽업요청시간을 선택해주세요.</div>,
  //     });
  //     return;
  //   }

  //   if (
  //     this.state.paymentMethod === paymentMethodCode.installment &&
  //     orderPrice !== calcPriceOfOrderPayments(this.state.orderPayments)
  //   ) {
  //     Modal.error({
  //       title: "접수요청 오류",
  //       content: (
  //         <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
  //       ),
  //     });
  //     return;
  //   }

  //   const orderPayments =
  //     this.state.paymentMethod === paymentMethodCode.installment
  //       ? this.state.orderPayments
  //       : [
  //           {
  //             paymentMethod: this.state.paymentMethod,
  //             paymentAmount: orderPrice,
  //             paymentStatus: 1,
  //           },
  //         ];

  //   const orderAwait = {
  //     latitude: this.state.targetLat,
  //     longitude: this.state.targetLng,
  //     orderPayments: orderPayments,
  //     destAddr1,
  //     destAddr2: destAddr2 ? destAddr2 : "",
  //     destAddr3,
  //     itemPrepared: this.state.itemPrepared,
  //     packAmount: this.state.packAmount,
  //     basicDeliveryPrice: this.state.deliveryBasicPrice,
  //     extraDeliveryPrice: this.state.deliveryAddPrice,
  //     deliveryPrice:
  //       this.state.deliveryBasicPrice + this.state.deliveryAddPrice,
  //     arriveReqTime: this.state.pickupTime,
  //     ncashPayEnabled: true,
  //     orderPrice,
  //     custPhone,
  //     ...form.getFieldsValue(["custMessage"]),
  //     // bmOrderCode:
  //     //   !this.state.isBaeminOrder || this.state.orderCode == ""
  //     //     ? null
  //     //     : this.state.orderCode,
  //     id: this.state.id ? this.state.id : uuidv4(),
  //     frIdx: this.props.loginReducer.loginInfo.idx,
  //     orderDate: moment().format("YYYY-MM-DD HH:mm"),
  //     orderPayments,
  //     waitingStatus: true,
  //   };


  //   if (this.state.id) {
  //     const result = await updateOrderAwaitAsync(orderAwait);

  //     if (result === "SUCCESS") {

  //       await this.getOrderAwaitList();

  //       this.props.alert.show(
  //         "멀티포스 대기주문 수정 요청이 성공적으로 접수되었습니다."
  //       );
  //       this.formRef.current.resetFields();
  //       this.setState({
  //         id: null,
  //       });
  //       this.props.history.push("/delivery");
  //     } else {
  //       let message =
  //         "시스템에러로 멀티포스 대기주문 수정 요청에 실패하였습니다. 잠시 후 다시 시도해주세요.";
  //       Modal.error({
  //         title: "멀티포스 대기주문 요청 실패",
  //         content: <div>{message}</div>,
  //         onOk() {},
  //       });
  //     }
  //   } else {
  //     const result = await createOrderAwaitAsync(orderAwait);

  //     if (result === "SUCCESS") {
  //       this.props.addWaitingOrder({
  //         ...orderAwait,
  //         orderDate: moment().format("YYYY-MM-DD HH:mm"),
  //         orderCode: this.state.orderCode,
  //         isBaeminOrder: this.state.isBaeminOrder,
  //         orderPayments,
  //       });

  //       this.props.alert.show(
  //         "멀티포스 대기주문 요청이 성공적으로 접수되었습니다."
  //       );
  //       this.formRef.current.resetFields();
  //       this.props.history.push("/delivery");
  //     } else {
  //       let message =
  //         "시스템에러로 멀티포스 대기주문 요청에 실패하였습니다. 잠시 후 다시 시도해주세요.";
  //       Modal.error({
  //         title: "멀티포스 대기주문 요청 실패",
  //         content: <div>{message}</div>,
  //         onOk() {},
  //       });
  //     }
  //   }
  // };

  showWaitingOrder = () => {
    this.setState({ waitingOrderModalOpen: true });
  };
  showOrder = () => {
    this.setState({ posOrderModalOpen: true });
  };
  handleAddOrUpdateWaitingOrder = () => {
    // 배민 / 블릭트 경로 통해서 들어오는 대기주문 형식
    // {
    //  ******* id : => createOrderAwait 메소드 내에서 맨들어서 넣어줌 *************
    //   orderCode: order.orderCode ? order.orderCode : null,
    //   paymentMethod: order.paymentMethod,
    //   custPhone: order.phone,
    //   destAddr1: order.destAddr1,
    //   destAddr2: order.destAddr2,
    //   destAddr3: order.destAddr3,
    //   orderPrice: order.price,
    //   orderDate: order.date,
    //   custMessage: order.memo,
    //   isBaeminOrder: order.isBaeminOrder,
    //   basicDeliveryPrice: distRes.deliveryBasicPrice,
    //   extraDeliveryPrice: distRes.deliveryAddPrice,
    // }
    updateManualPickupTimeSetup(false);
    const form = this.formRef.current;
    const custPhone = form.getFieldValue('custPhone');
    const orderPrice = parseInt(
      (form.getFieldValue('orderPrice') + '').replace(/,/g, '')
    );
    const orderPayments =
      this.state.paymentMethod === paymentMethodCode.installment
        ? this.state.orderPayments
        : [
            {
              paymentMethod: this.state.paymentMethod,
              paymentAmount: orderPrice,
              paymentStatus: 1,
            },
          ];

    if (custPhone === '' || isNaN(custPhone)) {
      Modal.info({
        title: '전화번호 오류',
        content: '전화번호를 정확히 입력해주세요.',
        ...modalStyle,
      });
      return;
    }

    if (isNaN(orderPrice)) {
      Modal.info({
        title: '주문금액 오류',
        content: '주문금액을 다시 한번 확인해주세요.',
        ...modalStyle,
      });
      return;
    }

    if (!this.isEnablePickupTime(this.state.pickupTimeIndex)) {
      Modal.error({
        title: '요청시간 오류',
        content: <div>가능한 픽업요청시간을 선택해주세요.</div>,
        ...modalErrorStyle,
      });
      return;
    }

    this.formRef.current.validateFields().then(async () => {
      let orderData = {
        id: this.state.id,
        orderCode: this.state.orderCode ? this.state.orderCode : null,
        custPhone,
        destAddr1: form.getFieldValue('destAddr1'),
        destAddr2:
          typeof form.getFieldValue('destAddr2') === 'undefined'
            ? ''
            : form.getFieldValue('destAddr2'),
        destAddr3: form.getFieldValue('destAddr3'),
        orderPrice: orderPrice,
        orderPayments,
        // paymentMethod: this.state.paymentMethod,
        orderDate: this.state.orderDate,
        custMessage: form.getFieldValue('custMessage'),
        isBaeminOrder: this.state.isBaeminOrder,
        basicDeliveryPrice: this.state.deliveryBasicPrice,
        extraDeliveryPrice: this.state.deliveryAddPrice,
        arriveReqTime: pickupTimeValue[this.state.pickupTimeIndex],
        error: false,
        ////////////////////////////////////////////////////////
        // waiting: this.state.bmOrderCode ? false : true,
        // paymentMethod: this.state.paymentMethod,
        // custPhone: form.getFieldValue("custPhone").replace(/-/g, ""),
        // destAddr1: form.getFieldValue("destAddr1"),
        // destAddr2:
        //   typeof form.getFieldValue("destAddr2") === "undefined"
        //     ? ""
        //     : form.getFieldValue("destAddr2"),
        // destAddr3: form.getFieldValue("destAddr3"),
        // custMessage: form.getFieldValue("custMessage"),
        // orderPrice: orderPrice,
        // orderPayments: orderPayments,
        // itemPrepared: this.state.itemPrepared,
        // packAmount: this.state.packAmount,
        // pickupTime: this.state.pickupTime,

        // basicDeliveryPrice: this.state.deliveryBasicPrice,
        // extraDeliveryPrice: this.state.deliveryAddPrice,
      };

      // redis set이라서 사실 create나 update나 차이가 없음
      // key expire 설정이 다르구나

      //TODO - solmea : 접수요청 탭에서 수동접수를 했을 경우, 자동접수가 활성되어 있어도 배달현황에서 awaitOrder폴링 시간만큼 대기로 보여질 수 있다.
      //자동접수 코드(Header.js::autoConfirmOrder())를 여기에도 복붙하기엔 중복코드가 많아보여서 일단 보류, 주문관련 기능 공통모듈로 리팩토링하거나 자동접수 구조를 변경하면 이곳에도 검증해주자
      if (this.state.id) {
        /*TODO ojoomi d1 정식서비스 후 주석해제
        const cloudflareOrderAwaitByIdRes = await getOrderAwaitByIdAtCloudFlareWorker(this.state.id);
        const orderAwait = cloudflareOrderAwaitByIdRes?.data?.orderAwait;
        if (orderAwait.constructor === Object && Object.keys(orderAwait).length > 0) {
          const res = await editOrderAwaitAtCloudFlareWorker(orderData);
          if (res.status !== 200) {
            console.error(`대기주문 수정 error, editOrderAwaitAtCloudFlareWorker 확인 : res: ${res}`);
            orderData.error = true;
            this.props.updateWaitingOrder(orderData);
          }
        } else {*/
          const res = await updateOrderAwaitAsync(orderData);
          if (res !== 'SUCCESS') {
            orderData.error = true;
            this.props.updateWaitingOrder(orderData);
          }
        /*}*/
      } else {
        const res = await createOrderAwaitAsync(orderData);// TODO ojoomi #6682일감에 따라 d1 정식배포전까지 대기주문 생성은 기존 redis에 write하도록 변경
        /*const res = await createOrderAwaitAtCloudFlareWorker(orderData); // 대기주문 redis => clf d1으로 관리하도록 변경*/
        /*if (res.data.result.toUpperCase() !== 'SUCCESS') {*/ //TODO ojoomi
        if (res?.toUpperCase() !== 'SUCCESS') {
          orderData.error = true;
          this.props.addWaitingOrder(orderData);
        }
      }

      await this.getOrderAwaitList();

      this.props.alert.show('대기 주문을 성공적으로 등록 했습니다.');
      this.formRef.current.resetFields();

      this.setState({
        orderIdx: 0,
        orderCode: null,
        isBaeminOrder: false,
        waiting: false,
        orderDate: '',
        destAddr1: '',
        destAddr2: '',
        destAddr3: '',
        itemPrepared: false,
        packAmount: 1,
        dist: 0,
        deliveryBasicPrice: 0,
        deliveryAddPrice: 0,
        paymentMethod: defaultConst.paymentMethod,
        pickupTimeIndex: defaultConst.pickupTime,
        orderPayments: [],
        frLat: this.props.loginReducer.loginInfo.latitude,
        frLng: this.props.loginReducer.loginInfo.longitude,
        targetLat: 0,
        targetLng: 0,
      });

      this.props.history.push('/delivery');
    });
  };

  getOrderAwaitList = async () => {
    //TODO ojoomi d1 정식서비스 후 주석해제
    const res = await httpPost(httpUrl.getOrderAwaitList, [], {}, true);
    /*const cloudflareOrderAwaitRes = await getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker(); // cloudflare worker d1에서 대기주문 가져오기.*/

    let list = [];
    res.data.orderAwaitList.forEach((stringOrder) => {
      list.push(JSON.parse(stringOrder));
    });
    // cloudflare worker d1에서 대기주문 가져오기.
    /*let cloudflareOrderAwaitList = [];
    if (cloudflareOrderAwaitRes.status === 200 && Array.isArray(cloudflareOrderAwaitRes?.data?.orderAwaitList)
        && cloudflareOrderAwaitRes?.data?.orderAwaitList?.length > 0) {
      cloudflareOrderAwaitList = cloudflareOrderAwaitRes?.data?.orderAwaitList;
    }
    if (Array.isArray(cloudflareOrderAwaitList) && cloudflareOrderAwaitList.length > 0) {
      cloudflareOrderAwaitList.forEach((orderAwait) => {
        list.push({...orderAwait});
      });
    }*/


    for (let i = 0; i < list.length; i++) {
      let orderAwait = list[i];
      this.updateReducerForWaitingOrder(orderAwait);
    }

    for (let i = 0; i < this.props.posReducer.waitingOrders.length; i++) {
      const wo = this.props.posReducer.waitingOrders[i];

      if (
        wo.id &&
        list.findIndex((orderAwait) => orderAwait.id === wo.id) < 0
      ) {
        if (wo.error) {
          wo.error = false;
          await createOrderAwaitAsync(wo); // TODO ojoomi
          /*await createOrderAwaitAtCloudFlareWorker(wo); // 대기주문 redis => clf d1으로 관리하도록 변경*/
        } else {
          this.props.removeWaitingOrderByOrderAwaitId(wo.id);
        }
      }
    }
  };

  handleStorageOrderInfo = (custPhone, orderInfo) => {
    const self = this;
    const orderPrice = this.formRef.current.getFieldValue('orderPrice');

    this.setState({
      custMessage: this.orderInfos.filter((x) => x.id === custPhone)[0]
        .custMessage,
    });

    Modal.confirm({
      ...modalStyle,
      content: `'${custPhone}' 접수 이력이 있습니다. 기존 주문정보를 불러 오시겠습니까?`,
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        self.updateCallData({
          ...orderInfo,
          orderIdx: -1,
          orderPrice,
          paymentMethod: self.state.paymentMethod,
          orderPayments: self.state.orderPayments,
          itemPrepared: self.state.itemPrepared,
          packAmount: self.state.packAmount,
          arriveReqTime: pickupTimeValue[self.state.pickupTimeIndex],
          waiting: false,
          id: null,
        });

        if (self.state.phoneInputModalOpen) {
          self.setState({
            phoneInputModalOpen: false,
          });
        }
      },
      onCancel() {
        self.setState({
          orderCount: orderInfo.orderCount,
        });
      },
    });
  };

  handleInquiryOrder = (custPhone) => {
    if (!custPhone || custPhone == '' || custPhone.length < 4) return;
    custPhone = custPhone.replace(/-/g, '');
    const localstorageOrderInfo = this.orderInfos.find(
      (x) => x.id === custPhone
    );
    if (localstorageOrderInfo) {
      this.handleStorageOrderInfo(custPhone, localstorageOrderInfo);
      return;
    }

    const orderInfo = this.cloudFlareOrderInfo.find(
      (x) => x.metadata && x.metadata.id === custPhone
    );
    if (orderInfo) {
      const self = this;
      const orderPrice = this.formRef.current.getFieldValue('orderPrice');

      this.setState({
        custMessage: this.cloudFlareOrderInfo.filter(
          (x) => x.metadata && x.metadata.id === custPhone
        )[0].custMessage,
      });

      Modal.confirm({
        ...modalStyle,
        content: `'${custPhone}' 접수 이력이 있습니다. 기존 주문정보를 불러 오시겠습니까?`,
        okText: '확인',
        cancelText: '취소',
        async onOk() {
          const orderInfo = await getOrderInfoDetailFromCloudFlareWorker(
            custPhone
          );
          if (orderInfo === null) {
            Modal.warn({
              title: '주문정보 조회 실패',
              content: '주문정보 조회에 실패했습니다. 다시 로그인해주세요.',
              ...modalStyle,
            });
            return;
          }
          self.updateCallData({
            ...orderInfo,
            orderIdx: -1,
            orderPrice,
            paymentMethod: self.state.paymentMethod,
            orderPayments: self.state.orderPayments,
            itemPrepared: self.state.itemPrepared,
            packAmount: self.state.packAmount,
            arriveReqTime: pickupTimeValue[self.state.pickupTimeIndex],
            waiting: false,
            id: null,
          });

          if (self.state.phoneInputModalOpen) {
            self.setState({
              phoneInputModalOpen: false,
            });
          }
        },
        onCancel() {
          self.setState({
            orderCount: orderInfo.orderCount,
          });
        },
      });
    }
  };
  // handleCall = () => {
  //     const action =  global.executeBridgeAction({ action: 'GetOrders', message: 'TEST Message' });
  //     action.then((res) => {
  //         alert(JSON.stringify(res));
  //     }).catch((e) => {
  //     });
  // }
  isEnablePickupTime = (id) => {
    const { basicPickupTime, delayPickupTime } =
      this.props.pickupTimeReducer.pickupTimeInfo;
    const fastestDelayTime = delayPickupTime + basicPickupTime;
    if (typeof id !== 'number' || id === -1) {
      return false;
    }
    return pickupTimeValue[id] >= fastestDelayTime;
  };

  calculatePickupTimeIdx = (refPickupTimeIndex, pickUpTime) => {
    const calculated =
      pickupTimeValue[refPickupTimeIndex] >= pickUpTime
        ? pickupTimeValue[refPickupTimeIndex]
        : pickUpTime;
    return pickupTimeValue.indexOf(calculated);
  };

  initializePickupTime = () => {
    // const totalDelayTime =
    //   this.state.deliveryData.delayPickupTime + this.state.frBasicPickupTime;
    const { basicPickupTime, delayPickupTime, manualPickupTimeSetup } =
      this.props.pickupTimeReducer.pickupTimeInfo;
    const totalDelayTime = basicPickupTime + delayPickupTime;

    if (!this.state.initializePickupTimeCnt) {
      // 처음 한번만 로딩되는 코드

      const refPickupTimeIdx = reactLocalStorage.getObject(
        Const.appName + '#refPickupTime'
      );

      // 초기 지연해제상태의 기본 픽업시간 없을 시 값 세팅
      const newRefPickUpTimeIdx = pickupTimeValue.indexOf(totalDelayTime);

      if (refPickupTimeIdx == null) {
        reactLocalStorage.setObject(
          Const.appName + '#refPickupTime',
          newRefPickUpTimeIdx
        );
      }

      const pickupTimeIdx = this.calculatePickupTimeIdx(
        refPickupTimeIdx,
        totalDelayTime
      );

      if (!manualPickupTimeSetup) {
        this.setState({
          pickupTimeIndex: pickupTimeIdx,
          initializePickupTimeCnt: true,
        });
      }
    }
  };

  findAddress = () => {
    // console.log('this.state.tableDataEnd');
    // console.log(this.state.tableDataEnd);

    if (this.state.tableDataEnd) return;
    if (this.state.addrTableEnd) {
      // console.log('findAddressAll');
      this.findAddressAll();
    } else {
      // console.log('findAddressEx');
      this.findAddressEx();
    }
  };
  findAddressAll = () => {
    const confmKey = 'U01TX0FVVEgyMDIxMDQxMDIzMjg0MDExMTAzNDk=';
    const currentPage = parseInt(this.state.tableDataCurrent) + 1;
    const countPerPage = pageSize;
    const keyword =
      this.state.branchName +
      ' ' +
      // (this.state.selectedDong.idx === 0 ? "" : this.state.selectedDong.name) +
      // " " +
      this.formRef.current.getFieldValue('destAddr1');
    const resultType = 'json';
    const url =
      'https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do?' +
      'confmKey=' +
      confmKey +
      '&currentPage=' +
      currentPage +
      '&countPerPage=' +
      countPerPage +
      '&keyword=' +
      keyword +
      '&resultType=' +
      resultType;

    // console.log(url);

    Axios({
      method: 'GET',
      url: url,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        // console.log('findAll response');
        // console.log(response);
        const results = JSON.parse(
          response.data.substring(1, response.data.length - 1)
        ).results;
        if (results.juso == null) {
          this.setState({ errorMessage: results.common.errorMessage });
        } else {
          let tableData = results.juso;
          if (results.juso.length === 0) {
            this.setState({ tableDataEnd: true, errorMessage: '' });
            return;
          }
          if (this.state.tableDataCurrent === results.common.currentPage) {
            tableData = [];
          }

          // console.log('tableData');
          // console.log(tableData);
          this.setState({
            tableData: this.state.tableData.concat(tableData),
            tableDataCurrent: results.common.currentPage,
            errorMessage: '',
          });
        }
      })
      .catch((e) => {
        this.setState({ errorMessage: 'error' });

        // console.log(e);
      });
  };
  findAddressEx = () => {
    httpGet(
      httpUrl.addrExList,
      [
        pageSize,
        parseInt(this.state.tableDataCurrent) + 1,
        '',
        this.formRef.current.getFieldValue('destAddr1'),
      ],
      {}
    )
      .then((res) => {
        if (res.result === 'SUCCESS') {
          // console.log('findEx res');
          // console.log(res.data);
          if (res.data.addrAptBranches.length < pageSize) {
            // console.log('addrList end');
            this.setState({ addrTableEnd: true, errorMessage: '' }, () =>
              this.findAddress()
            );
          }
          if (this.state.tableDataCurrent === res.result.currentPage) {
            res.result.addrAptBranches = [];
          }

          const tableData = res.data.addrAptBranches.map((row) => ({
            name: row.name,
            roadAddr: row.addr1,
            jibunAddr: row.addr3,
          }));
          // console.log('tableData');
          // console.log(tableData);
          this.setState({
            tableData: this.state.tableData.concat(tableData),
            tableDataCurrent: res.data.currentPage,
            errorMessage: '',
          });
        }
      })
      .catch((e) => {
        this.setState({ errorMessage: 'error' });

        // console.log(e);
      });
  };

  onSearch = () => {
    this.openKeyInputModal3();
    this.setState(
      {
        tableData: [],
        tableDataCurrent: 0,
        tableDataEnd: false,
        addrTableEnd: false,
        errorMessage: '',
        searchAddressOpen: true,
      },
      () => {
        this.findAddress();
      }
    );
  };
  getBranchInfo = () => {
    // console.log('getBranchInfo');
    // console.log('getBranchInfo', this.props.loginReducer.loginInfo.branchIdx);
    httpGet(
      httpUrl.getBranchInfo,
      [this.props.loginReducer.loginInfo.branchIdx],
      {}
    ).then((res) => {
      if (res.result === 'SUCCESS') {
        const branchName = res.data?.branchName;
        Object.keys(branchAddressSearchKeyword).forEach((key) => {
          branchAddressSearchKeyword[key].forEach((branchKey) => {
            const re = new RegExp(branchKey);
            const res = branchName?.match(re);
            if (res) this.setState({ branchName: key });
            return;
          });
        });
      }
    });
  };

  callback = (data) => {
    this.setState({
      getJibunAddr: data,
    });
  };

  loadOrderInfo = async () => {
    // 기존 로컬스토리지 주문정보
    const orderInfos = reactLocalStorage.getObject(
      Const.appName + '#orderInfo'
    );
    // console.log('===== storage orderinfos =====');
    // console.log(orderInfos);
    if (Array.isArray(orderInfos)) {
      this.orderInfos = orderInfos;
    }

    // cloudflare 주문 정보
    try {
      const orderInfos = await getOrderInfoListFromCloudFlareWorker();
      if (orderInfos && Array.isArray(orderInfos)) {
        this.cloudFlareOrderInfo = orderInfos;
      }
    } catch (e) {
      console.error('Error while loading orderInfo', e);
    }
  };

  updateReducerForWaitingOrder = (orderAwait) => {
    if (this.props.posReducer.waitingOrders.find((order) => orderAwait.id === order.id)) {
      this.props.updateWaitingOrder(orderAwait);
    } else {
      this.props.addWaitingOrder(orderAwait);
    }
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };
    const { close } = this.props;
    const skinType = Const.skinType.toUpperCase();
    return (
      <div className="body-main">
        <div className="body-main-bg">
          <div className="body-content">
            <div className="body-content-all">
              <div className="body-content-title">접수요청</div>

              <div className="body-content-title-right-wrapper">
                <Badge count={this.props.posReducer.waitingOrders.length}>
                  <div
                    className="body-content-title-right"
                    onClick={this.showWaitingOrder}>
                    대기주문확인
                  </div>
                </Badge>
                {/* <Badge count={this.props.posReducer.posOrders.length}>
                  <div
                    className="body-content-title-right"
                    onClick={this.showOrder}
                  >
                    POS주문확인
                  </div>
                </Badge> */}
                {this.state.waitingOrderModalOpen && (
                  <WaitingOrderModal
                    close={() => {
                      this.setState({ waitingOrderModalOpen: false });
                    }}
                    onSelect={this.updateCallData}
                  />
                )}
                <PosOrderModal
                  isOpen={this.state.posOrderModalOpen}
                  close={() => {
                    this.setState({ posOrderModalOpen: false });
                  }}
                  onSelect={this.updateCallData}
                />
              </div>

              <div className="mainKeypad-addr desk">
                <KeyInputModal
                  isOpen={this.state.keyInputModalOpen}
                  close={this.closeKeyInputModal}
                  keyin={(data) => {
                    const str = this.formRef.current.getFieldValue('destAddr2');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str = this.formRef.current.getFieldValue('destAddr2');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModalOpen: false });
                  }}
                />
              </div>
              <div className="mainKeypad-addr pos">
                <KeyInputModal
                  isOpen={this.state.keyInputModalOpen}
                  close={this.closeKeyInputModal}
                  keyin={(data) => {
                    const str = this.formRef.current.getFieldValue('destAddr2');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str = this.formRef.current.getFieldValue('destAddr2');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModalOpen: false });
                  }}
                />
              </div>
              <div className="mainKeypad-message desk">
                <KeyInputModal
                  isOpen={this.state.keyInputModal2Open}
                  close={this.closeKeyInputModal2}
                  keyin={(data) => {
                    const str =
                      this.formRef.current.getFieldValue('custMessage');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      custMessage: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str =
                      this.formRef.current.getFieldValue('custMessage');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      custMessage: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModal2Open: false });
                  }}
                />
              </div>
              <div className="mainKeypad-message pos">
                <KeyInputModal
                  isOpen={this.state.keyInputModal2Open}
                  close={this.closeKeyInputModal2}
                  keyin={(data) => {
                    const str =
                      this.formRef.current.getFieldValue('custMessage');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      custMessage: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str =
                      this.formRef.current.getFieldValue('custMessage');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      custMessage: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModal2Open: false });
                  }}
                />
              </div>
              <div className="mainKeypad-addr desk">
                <KeyInputModal
                  isOpen={this.state.keyInputModal3Open}
                  close={this.closeKeyInputModal}
                  keyin={(data) => {
                    const str = this.formRef.current.getFieldValue('destAddr1');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr1: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str = this.formRef.current.getFieldValue('destAddr1');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr1: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModal3Open: false });
                  }}
                />
              </div>
              <div className="mainKeypad-addr pos">
                <KeyInputModal
                  isOpen={this.state.keyInputModalOpen3}
                  close={this.closeKeyInputModal}
                  keyin={(data) => {
                    const str = this.formRef.current.getFieldValue('destAddr1');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str
                        ? Hangul.assemble([...Hangul.disassemble(str), data])
                        : data + '',
                    });
                  }}
                  backspace={() => {
                    const str = this.formRef.current.getFieldValue('destAddr1');
                    // console.log(str);
                    this.formRef.current.setFieldsValue({
                      destAddr2: str ? str.substr(0, str.length - 1) : '',
                    });
                  }}
                  ok={() => {
                    this.setState({ keyInputModalOpen3: false });
                  }}
                />
              </div>

              <div className="body-content-sub mobileoff">필수입력사항</div>
              <div className={skinType === "GOGOIT" ? "gogoit-main-dots mobileoff" : "main-dots mobileoff"}/>
              <div className="body-content-sub mobile">
                필수입력사항 <span className={skinType === "GOGOIT" ? "gogoit-main-dots" : "main-dots"} />
              </div>
            </div>
          </div>
          {this.state.paymentOpen && (
            <PaymentDialog
              close={this.closePaymentModal}
              orderPayments={this.state.orderPayments}
              handlePaymentChange={this.handlePaymentChange}
              editable={true}
              orderPrice={
                typeof this.formRef.current.getFieldValue('orderPrice') ===
                'undefined'
                  ? 0
                  : parseInt(
                      (
                        this.formRef.current.getFieldValue('orderPrice') + ''
                      ).replace(/,/g, '')
                    )
              }
            />
          )}
          <Form
            ref={this.formRef}
            {...formItemLayout}
            onFinish={this.handleSubmit}>
            <div className="body-element">
              <div className="body-element-all">
                {/* 고객전화번호 입력 */}
                <div className="body-element-block">
                  <div className="body-element-block-title">고객 전화번호</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div className="body-element-block-title-input">
                    <FormItem
                      name="custPhone"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "고객 전화번호를 입력해주세요",
                      //   },
                      // ]}
                    >
                      <Input
                        id="input1"
                        placeholder={'고객 전화번호를 - 없이 입력해 주세요'}
                        onFocus={this.openPhoneInputModal}
                        autoComplete="off"
                        onChange={(e) => {
                          this.handleInquiryOrder(e.target.value);
                        }}
                      />
                    </FormItem>
                  </div>
                  <div className="mainKeypad-phone">
                    <PhoneInputModal
                      isOpen={this.state.phoneInputModalOpen}
                      close={this.closePhoneInputModal}
                      keyin={(data) => {
                        const str =
                          this.formRef.current.getFieldValue('custPhone');
                        // console.log(str);
                        this.formRef.current.setFieldsValue({
                          custPhone: str ? str + data + '' : data + '',
                        });
                        this.handleInquiryOrder(
                          str ? str + data + '' : data + ''
                        );
                      }}
                      backspace={() => {
                        const str =
                          this.formRef.current.getFieldValue('custPhone');
                        // console.log(str);
                        this.formRef.current.setFieldsValue({
                          custPhone: str ? str.substr(0, str.length - 1) : '',
                        });
                      }}
                      reset={() => {
                        this.formRef.current.setFieldsValue({
                          custPhone: '',
                        });
                      }}
                      ok={() => {
                        const value =
                          this.formRef.current.getFieldValue('custPhone');
                        if (value == '') {
                          Modal.error({
                            title: '전화번호 오류',
                            content: (
                              <div>
                                유효하지 않는 전화번호입니다. 전화번호를
                                올바르게 입력해주세요.
                              </div>
                            ),
                            ...modalErrorStyle,
                          });
                        } else {
                          this.setState({ phoneInputModalOpen: false });
                          this.handleInquiryOrder(value);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* 주문금액 입력 */}
                <div className="body-element-block2">
                  <div className="body-element-block2-title">주문금액</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div className="body-element-block2-title-input">
                    <FormItem
                      name="orderPrice"
                      rules={[
                        { required: true, message: '주문금액을 입력해주세요' },
                      ]}>
                      <Input
                        id="input1"
                        placeholder={'주문금액을 입력해 주세요'}
                        onFocus={this.openPriceInputModal}
                        autoComplete="off"
                        onChange={() => this.onUpdateOverPrice}
                      />
                    </FormItem>
                  </div>
                  <div className="mainKeypad-price">
                    <PriceInputModal
                      isOpen={this.state.priceInputModalOpen}
                      close={this.closePriceInputModal}
                      keyadd={(data) => {
                        let str = (
                          this.formRef.current.getFieldValue('orderPrice') + ''
                        ).replace(/,/g, '');
                        let value = 0;
                        if (str && !isNaN(str)) value = parseInt(str);

                        // console.log(value);
                        this.formRef.current.setFieldsValue({
                          orderPrice: comma(value + data),
                        });
                        this.onUpdateOverPrice();
                      }}
                      keyin={(data) => {
                        let str = (
                          this.formRef.current.getFieldValue('orderPrice') + ''
                        ).replace(/,/g, '');
                        let value = 0;
                        if (str && !isNaN(str)) {
                          value = parseInt(str);
                        }
                        this.formRef.current.setFieldsValue({
                          orderPrice: comma(parseInt(value + '' + data)),
                        });
                        this.onUpdateOverPrice();
                      }}
                      backspace={() => {
                        let str = (
                          this.formRef.current.getFieldValue('orderPrice') + ''
                        ).replace(/,/g, '');
                        let value = 0;
                        if (str && !isNaN(str)) value = parseInt(str);

                        // console.log(value);
                        this.formRef.current.setFieldsValue({
                          orderPrice: comma(parseInt(value / 10)),
                        });
                        this.onUpdateOverPrice();
                      }}
                      reset={() => {
                        this.formRef.current.setFieldsValue({
                          orderPrice: '',
                        });
                        this.onUpdateOverPrice();
                      }}
                      ok={() => {
                        this.setState({ priceInputModalOpen: false });
                      }}
                    />
                  </div>
                </div>
                {/* 결제수단 선택 */}
                <div className="body-element-block3 desk">
                  <div className="body-element-block3-title">결제수단</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div className="body-element-block3-title-btn">
                    {/* {paymentMethodString.map((row, index) => {
                                            if (index == 0) return;
                                            return (
                                                <div key={index} className={"body-element-block3-title-btn-menu" + ((index == this.state.paymentMethod) ? ' active' : '')} onClick={() => this.setState({ paymentMethod: index })}>
                                                    {row}
                                                </div>
                                            );
                                        })} */}
                    <div
                      key={3}
                      className={paymentMethodCode.advance === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                        paymentMethodCode.advance === this.state.paymentMethod
                          ? 'body-element-block3-title-btn-menu active'
                          : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.advance
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.advance]}
                    </div>
                    <div
                      key={4}
                      className={paymentMethodCode.installment === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                          paymentMethodCode.installment === this.state.paymentMethod
                              ? 'body-element-block3-title-btn-menu active'
                              : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.installment
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.installment]}
                    </div>
                    <div
                      key={1}
                      className={paymentMethodCode.card === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.card === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.card
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.card]}
                    </div>
                    <div
                      key={2}
                      className={paymentMethodCode.cash === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.cash === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.cash
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.cash]}
                    </div>
                  </div>
                </div>

                {/* 결제수단 선택 - 반응형*/}
                <div className="body-element-block3 pos">
                  <div className="body-element-block3-title">결제수단</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div className="body-element-block3-title-btn">
                    {/* {paymentMethodString.map((row, index) => {
                                            if (index == 0) return;
                                            return (
                                                <div key={index} className={"body-element-block3-title-btn-menu" + ((index == this.state.paymentMethod) ? ' active' : '')} onClick={() => this.setState({ paymentMethod: index })}>
                                                    {row}
                                                </div>
                                            );
                                        })} */}
                    <div>
                      <div
                        key={3}
                        className={paymentMethodCode.advance === this.state.paymentMethod && skinType === "GOGOIT" ?
                            'gogoit-body-element-block3-title-btn-menu active'
                            : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                                paymentMethodCode.advance === this.state.paymentMethod
                                    ? 'body-element-block3-title-btn-menu active'
                                    : 'body-element-block3-title-btn-menu'
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.advance
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.advance]}
                      </div>
                      <div
                        key={4}
                        className={paymentMethodCode.installment === this.state.paymentMethod && skinType === "GOGOIT" ?
                            'gogoit-body-element-block3-title-btn-menu active'
                            : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                                paymentMethodCode.installment === this.state.paymentMethod
                                    ? 'body-element-block3-title-btn-menu active'
                                    : 'body-element-block3-title-btn-menu'
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.installment
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.installment]}
                      </div>
                      <div
                        key={1}
                        className={paymentMethodCode.card === this.state.paymentMethod && skinType === "GOGOIT" ?
                            'gogoit-body-element-block3-title-btn-menu active'
                            : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                                paymentMethodCode.card === this.state.paymentMethod
                                    ? 'body-element-block3-title-btn-menu active'
                                    : 'body-element-block3-title-btn-menu'
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.card
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.card]}
                      </div>
                      <div
                        key={2}
                        className={paymentMethodCode.cash === this.state.paymentMethod && skinType === "GOGOIT" ?
                            'gogoit-body-element-block3-title-btn-menu active'
                            : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                                paymentMethodCode.cash === this.state.paymentMethod
                                    ? 'body-element-block3-title-btn-menu active'
                                    : 'body-element-block3-title-btn-menu'
                        }
                        onClick={() =>
                          this.onCheckAndUpdatePaymentMethod(
                            paymentMethodCode.cash
                          )
                        }>
                        {paymentMethodString[paymentMethodCode.cash]}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="body-element-block3 mobile">
                  <div className="body-element-block3-title">결제수단</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div className="body-element-block3-title-btn">
                    {/* {paymentMethodString.map((row, index) => {
                                            if (index == 0) return;
                                            return (
                                                <div key={index} className={"body-element-block3-title-btn-menu" + ((index == this.state.paymentMethod) ? ' active' : '')} onClick={() => this.setState({ paymentMethod: index })}>
                                                    {row}
                                                </div>
                                            );
                                        })} */}
                    <div
                      key={3}
                      className={paymentMethodCode.advance === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.advance === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.advance
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.advance]}
                    </div>
                    <div
                      key={4}
                      className={paymentMethodCode.installment === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.installment === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.installment
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.installment]}
                    </div>
                    <div
                      key={1}
                      className={paymentMethodCode.card === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.card === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.card
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.card]}
                    </div>
                    <div
                      key={2}
                      className={paymentMethodCode.cash === this.state.paymentMethod && skinType === "GOGOIT" ?
                          'gogoit-body-element-block3-title-btn-menu active'
                          : skinType === "GOGOIT" ? 'gogoit-body-element-block3-title-btn-menu':
                              paymentMethodCode.cash === this.state.paymentMethod
                                  ? 'body-element-block3-title-btn-menu active'
                                  : 'body-element-block3-title-btn-menu'
                      }
                      onClick={() =>
                        this.onCheckAndUpdatePaymentMethod(
                          paymentMethodCode.cash
                        )
                      }>
                      {paymentMethodString[paymentMethodCode.cash]}
                    </div>
                  </div>
                </div>

                {/* 고객 주소 입력 */}
                <div
                  className="body-element-block4"
                  onBlur={(e) => {
                    if (!e.relatedTarget) {
                      this.setState({ searchAddressOpen: false });
                    }
                  }}>
                  <div className="body-element-block4-title">고객 주소</div>
                  <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  <div>
                    {/* <div className="body-element-block4-title-input"> */}
                    <div
                      className="body-element-block4-title-input"
                      onClick={this.openAddrModal}>
                      {/* <FormItem initialValue="" name="destAddr1"> */}
                      <FormItem
                        initialValue=""
                        name={
                          this.state.getJibunAddr ? 'destAddr3' : 'destAddr1'
                        }>
                        <Input
                          id="input2"
                          // onFocus={() => this.onSearch()}
                          // onKeyPress={(e) => {
                          //   if (e.key === "Enter") {
                          //     this.onSearch();
                          //   }
                          //   e.stopPropagation();
                          // }}
                          disabled
                          placeholder={'주소검색'}
                        />
                      </FormItem>
                    </div>
                    <div
                      className="body-element-block4-title-btn"
                      onClick={this.openAddrModal}
                      // onClick={this.onSearch}
                    >
                      <img
                        style={{ display: 'inline' }}
                        src={image.SearchIcon}
                        className="body-search"
                        alt=""
                      />
                    </div>
                    {!this.state.errorMessage &&
                      this.state.searchAddressOpen && (
                        <div
                          tabIndex={'0'}
                          className="mobileoff address-scroll-search">
                          <InfiniteScroll
                            dataLength={this.state.tableData.length}
                            next={this.findAddress}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              backgroundColor: 'white',
                            }}
                            hasMore={!this.tableDataEnd}
                            height={'20.5em'}>
                            {this.state.tableData.length > 0 ? (
                              this.state.tableData.map((row, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={
                                      'addr-content-main-block-field' +
                                      (index % 2 === 0 ? '' : ' odd')
                                    }
                                    onClick={() => {
                                      this.setAddress(row);
                                    }}>
                                    <div className="addr-content-main-block-field-text">
                                      {typeof row.name !== 'undefined' &&
                                        '[' + row.name + '] '}
                                      {row.roadAddr}
                                    </div>
                                    <div className="addr-content-main-block-field-text2"></div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="addr-content-main-block-field">
                                <div className="addr-content-main-block-field-text">
                                  검색 결과가 없습니다.
                                </div>
                              </div>
                            )}
                          </InfiniteScroll>
                        </div>
                      )}

                    {/* <div className="body-element-block4-disabled-input">
                      <FormItem
                        initialValue=""
                        name="destAddr1-submit"
                        rules={[
                          {
                            required: true,
                            message: "고객 주소를 입력해주세요",
                          },
                        ]}
                      >
                        <Input
                          id="disabled-input"
                          onFocus={() => this.onSearch()}
                          placeholder={"고객 주소를 입력해 주세요"}
                          disabled
                        />
                      </FormItem>
                    </div> */}
                  </div>

                  <div>
                    <div className="body-element-block4-title-input-sub2">
                      <FormItem
                        name="destAddr2"
                        rules={[
                          {
                            required: false,
                            message: '상세 주소를 입력해주세요',
                          },
                        ]}>
                        <Input
                          id="input3"
                          placeholder={'상세 주소를 입력해 주세요'}
                          onFocus={this.openKeyInputModal}
                          autoComplete="off"
                        />
                      </FormItem>
                    </div>
                    <div
                      className="body-element-block4-title-btn"
                      onClick={() => {
                        if (
                          this.state.frLat === 0 ||
                          this.state.frLng === 0 ||
                          this.state.targetLat === 0 ||
                          this.state.targetLng === 0
                        ) {
                          this.props.alert.show('위치정보를 찾을 수 없습니다.');
                          return;
                        }
                        this.openMapModal();
                      }}>
                      <img
                        style={{ display: 'inline' }}
                        src={image.MapIcon}
                        className="body-map"
                        alt=""
                      />
                    </div>
                    <MapModal
                      isOpen={this.state.mapModalOpen}
                      close={this.closeMapModal}
                      frLat={this.state.frLat}
                      frLng={this.state.frLng}
                      targetLat={this.state.targetLat}
                      targetLng={this.state.targetLng}
                      dist={this.state.dist}
                      deliveryBasicPrice={this.state.deliveryBasicPrice}
                      deliveryAddPrice={this.state.deliveryAddPrice}
                      destAddr1={this.state.destAddr1}
                      destAddr2={this.state.destAddr2}
                      destAddr3={this.state.destAddr3}
                    />
                  </div>
                </div>

                {/* 배송비 정보 입력 */}
                <div className="body-element-block5 desk">
                  <div className="body-element-block5-sub">
                    <div className="body-element-block5-title">
                      배송비 정보( VAT 별도 )
                    </div>
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  </div>

                  <div className="body-element-block5-input-sub">
                    <div className="body-element-block5-title-input">
                      <Input
                        id="input4"
                        value={'거리 : ' + formatKm(this.state.dist)}
                        disabled
                      />
                    </div>

                    {/* <div className="body-element-block5-title-input2">
                      <Input
                        id="input5"
                        value={
                          "배송비 : " + comma(this.state.deliveryBasicPrice)
                        }
                        disabled
                      />
                    </div> */}

                    <div className="main-element-menu-all">
                      <div
                        className="main-element-menu-check"
                        onClick={() => {
                          this.setState({ selectOpen: !this.state.selectOpen });
                        }}>
                        <div
                          className={this.state.selectOpen && skinType === "GOGOIT"
                              ? 'gogoit-main-element-menu-check-all-color'
                              : this.state.selectOpen
                                  ? 'main-element-menu-check-all-color'
                                  : 'main-element-menu-check-all'
                          }>
                          묶음 ({this.state.packAmount}개)
                          <img
                            style={{ display: 'inline' }}
                            src={
                              this.state.selectOpen ? image.SelectIcon : image.UnselectIcon
                            }
                            className="select-img"
                            alt=""
                          />
                        </div>
                        {this.state.selectOpen && (
                          <div className="main-element-menu-check-menu">
                            {Object.entries(packAmountCodeString).map(
                              ([key, value]) => (
                                <div>
                                  <div
                                    className={this.state.packAmount === parseInt(key) && skinType === "GOGOIT"
                                        ? 'gogoit-main-element-menu-check-element'
                                        : this.state.packAmount === parseInt(key)
                                            ? 'main-element-menu-check-element'
                                            : 'main-element-menu-check-element2'
                                    }
                                    onClick={() => {
                                      this.setState({
                                        packAmount: parseInt(key),
                                      });
                                    }}>
                                    {value}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="body-element-block5-title-input3">
                    <Input
                      id="input1"
                      value={"할증금액 : " + comma(this.state.deliveryAddPrice)}
                      disabled
                    />
                  </div> */}
                  <div className="body-element-block5-title-input3">
                    <Input
                      id="input1"
                      style={{ color: '#ff8a00' }}
                      value={
                        '총배송비 : ' +
                        comma(
                          this.state.deliveryBasicPrice +
                            this.state.deliveryAddPrice
                        )
                      }
                      disabled
                    />
                  </div>
                </div>

                {/* 배송비 정보 입력 -포스 */}

                <div className="body-element-block5 pos">
                  <div className="body-element-block5-sub">
                    <div className="body-element-block5-title">
                      배송비 정보( VAT 별도 )
                    </div>
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  </div>

                  <div className="body-element-block5-input-sub">
                    <div className="body-element-block5-title-input">
                      <Input
                        id="input4"
                        value={'거리 : ' + formatKm(this.state.dist)}
                        disabled
                      />
                    </div>

                    <div className="main-element-menu-all" onClick={close}>
                      <div
                        className="main-element-menu-check"
                        onClick={() => {
                          this.setState({ selectOpen: !this.state.selectOpen });
                        }}>
                        <div
                          className={this.state.selectOpen && skinType === "GOGOIT"
                              ? 'gogoit-main-element-menu-check-all-color'
                              : this.state.selectOpen
                                  ? 'main-element-menu-check-all-color'
                                  : 'main-element-menu-check-all'
                          }>
                          묶음 ({this.state.packAmount}개)
                          <img
                            style={{ display: 'inline' }}
                            src={
                              this.state.selectOpen ? image.SelectIcon : image.UnselectIcon
                            }
                            className="select-img"
                            alt=""
                          />
                        </div>
                        {this.state.selectOpen && (
                          <div className="main-element-menu-check-menu">
                            {Object.entries(packAmountCodeString).map(
                              ([key, value]) => (
                                <div>
                                  <div
                                    className={this.state.packAmount === parseInt(key) && skinType === "GOGOIT"
                                        ? 'gogoit-main-element-menu-check-element'
                                        : this.state.packAmount === parseInt(key)
                                            ? 'main-element-menu-check-element'
                                            : 'main-element-menu-check-element2'
                                    }
                                    onClick={() => {
                                      this.setState({
                                        packAmount: parseInt(key),
                                      });
                                    }}>
                                    {value}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="body-element-block5-input-sub">
                    <div className="body-element-block5-title-input2">
                      <Input
                        id="input5"
                        value={
                          "배송비 : " + comma(this.state.deliveryBasicPrice)
                        }
                        disabled
                      />
                    </div>
                    <div className="body-element-block5-title-input3">
                      <Input
                        id="input5"
                        value={
                          "할증금액 : " + comma(this.state.deliveryAddPrice)
                        }
                        disabled
                      />
                    </div>
                  </div> */}
                  <div className="body-element-block5-title-input3">
                    <Input
                      id="input1"
                      style={{ color: '#ff8a00' }}
                      value={
                        '총배송비 : ' +
                        comma(
                          this.state.deliveryBasicPrice +
                            this.state.deliveryAddPrice
                        )
                      }
                      disabled
                    />
                  </div>
                </div>

                {/* 배송비 정보 입력 - 모바일 */}

                <div className="body-element-block5 mobile">
                  <div className="body-element-block5-sub">
                    <div className="body-element-block5-title">
                      배송비 정보( VAT 별도 )
                    </div>
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  </div>

                  <div className="body-element-block5-input-sub">
                    <div className="body-element-block5-title-input">
                      <Input
                        id="input4"
                        value={'거리 : ' + formatKm(this.state.dist)}
                        disabled
                      />
                    </div>

                    {/* <div className="body-element-block5-title-input2">
                      <Input
                        id="input5"
                        value={
                          "배송비 : " + comma(this.state.deliveryBasicPrice)
                        }
                        disabled
                      />
                    </div> */}

                    <div className="main-element-menu-all ">
                      <div
                        className="main-element-menu-check"
                        onClick={() => {
                          this.setState({ selectOpen: !this.state.selectOpen });
                        }}>
                        <div
                          className={this.state.selectOpen && skinType === "GOGOIT"
                              ? 'gogoit-main-element-menu-check-all-color'
                              : this.state.selectOpen
                                  ? 'main-element-menu-check-all-color'
                                  : 'main-element-menu-check-all'
                          }>
                          묶음 ({this.state.packAmount}개)
                          <img
                            style={{ display: 'inline' }}
                            src={
                              this.state.selectOpen ? image.SelectIcon : image.UnselectIcon
                            }
                            className="select-img"
                            alt=""
                          />
                        </div>
                        {this.state.selectOpen && (
                          <div className="main-element-menu-check-menu">
                            {Object.entries(packAmountCodeString).map(
                              ([key, value]) => (
                                <div>
                                  <div
                                    className={this.state.packAmount === parseInt(key) && skinType === "GOGOIT"
                                        ? 'gogoit-main-element-menu-check-element'
                                        : this.state.packAmount === parseInt(key)
                                            ? 'main-element-menu-check-element'
                                            : 'main-element-menu-check-element2'
                                    }
                                    onClick={() => {
                                      this.setState({
                                        packAmount: parseInt(key),
                                      });
                                    }}>
                                    {value}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="body-element-block5-title-input3">
                    <Input
                      id="input1"
                      value={"할증금액 : " + comma(this.state.deliveryAddPrice)}
                      disabled
                    />
                  </div> */}
                  <div className="body-element-block5-title-input3">
                    <Input
                      id="input1"
                      style={{ color: '#ff8a00' }}
                      value={
                        '총배송비 : ' +
                        comma(
                          this.state.deliveryBasicPrice +
                            this.state.deliveryAddPrice
                        )
                      }
                      disabled
                    />
                  </div>
                </div>

                {/* 픽업요청시간 선택 */}
                <div className="body-element-block6 desk">
                  <div className="body-element-block6-title">
                    픽업요청 시간
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                    {/* temporary, riverstyx */}
                    <div className="body-element-block10-title-right">
                      <Checkbox
                        style={{ paddingLeft: 5.7, fontSize: '16px' }}
                        onChange={(e) =>
                          this.setState({ itemPrepared: e.target.checked })
                        }
                        checked={this.state.itemPrepared}>
                        조리완료
                      </Checkbox>
                    </div>
                  </div>

                  <div>
                    <div className="body-element-block6-title-btn">
                      {pickupTimeCode.map((row, index) => {
                        if (index === 0) return null;
                        const { delayPickupTime, basicPickupTime } =
                          this.props.pickupTimeReducer.pickupTimeInfo;
                        return pickupTimeValue[index] >=
                          delayPickupTime + basicPickupTime ? (
                          <div
                            key={index}
                            className={this.state.pickupTimeIndex === index && skinType === "GOGOIT" ?
                                'gogoit-body-element-block6-title-btn-menu active'
                                : skinType === "GOGOIT"
                                    ? 'gogoit-body-element-block6-title-btn-menu'
                                    : this.state.pickupTimeIndex === index
                                        ? 'body-element-block6-title-btn-menu active'
                                        : 'body-element-block6-title-btn-menu'
                            }
                            onClick={() => {
                              this.props.updateManualPickupTimeSetup(true);
                              this.setState({ pickupTimeIndex: index }, () => {
                                // this.setCurrentPickupTimeIndex(index);
                              });
                            }}>
                            {row}
                          </div>
                        ) : (
                          <div
                            key={index}
                            className={
                              'body-element-block6-title-btn-menu disable'
                            }>
                            {row}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* 픽업요청시간 선택 - 반응형*/}
                <div className="body-element-block6 pos">
                  <div className="body-element-block6-title">
                    픽업요청 시간
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  </div>
                  {/* temporary, riverstyx */}
                  <div className="body-element-block10-title-right">
                    <Checkbox
                      style={{ paddingLeft: 5.7, fontSize: '16px' }}
                      onChange={(e) => {
                        this.setState({ itemPrepared: e.target.checked });
                      }}
                      checked={this.state.itemPrepared}>
                      조리완료
                    </Checkbox>
                  </div>

                  <div>
                    <div className="body-element-block6-title-btn">
                      {pickupTimeCode.map((row, index) => {
                        if (index === 0) return null;
                        const { delayPickupTime, basicPickupTime } =
                          this.props.pickupTimeReducer.pickupTimeInfo;
                        return pickupTimeValue[index] >=
                          delayPickupTime + basicPickupTime ? (
                          <div
                            key={index}
                            className={this.state.pickupTimeIndex === index && skinType === "GOGOIT" ?
                                'gogoit-body-element-block6-title-btn-menu active'
                                : skinType === "GOGOIT"
                                    ? 'gogoit-body-element-block6-title-btn-menu'
                                    : this.state.pickupTimeIndex === index
                                        ? 'body-element-block6-title-btn-menu active'
                                        : 'body-element-block6-title-btn-menu'
                            }
                            onClick={() => {
                              this.props.updateManualPickupTimeSetup(true);
                              this.setState({ pickupTimeIndex: index }, () => {
                                // this.setCurrentPickupTimeIndex(index);
                              });
                            }}>
                            {row}
                          </div>
                        ) : (
                          <div
                            key={index}
                            className={
                              'body-element-block6-title-btn-menu disable'
                            }>
                            {row}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* 픽업요청시간 선택 - 모바일*/}

                <div className="body-element-block6 mobile">
                  <div className="body-element-block6-title">
                    픽업요청 시간
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                    {/* temporary, riverstyx */}
                    <div className="body-element-block10-title-right">
                      <Checkbox
                        style={{ paddingLeft: 105, fontSize: '16px' }}
                        onChange={(e) => {
                          this.setState({ itemPrepared: e.target.checked });
                        }}
                        checked={this.state.itemPrepared}>
                        조리완료
                      </Checkbox>
                    </div>
                  </div>

                  <div>
                    <div className="body-element-block6-title-btn">
                      {pickupTimeCode.map((row, index) => {
                        if (index === 0) return null;
                        const { delayPickupTime, basicPickupTime } =
                          this.props.pickupTimeReducer.pickupTimeInfo;
                        return pickupTimeValue[index] >=
                          delayPickupTime + basicPickupTime ? (
                          <div
                            key={index}
                            className={this.state.pickupTimeIndex === index && skinType === "GOGOIT" ?
                                'gogoit-body-element-block6-title-btn-menu active'
                                : skinType === "GOGOIT"
                                    ? 'gogoit-body-element-block6-title-btn-menu'
                                    : this.state.pickupTimeIndex === index
                                        ? 'body-element-block6-title-btn-menu active'
                                        : 'body-element-block6-title-btn-menu'
                            }
                            onClick={() => {
                              this.props.updateManualPickupTimeSetup(true);
                              this.setState({ pickupTimeIndex: index }, () => {
                                // this.setCurrentPickupTimeIndex(index);
                              });
                            }}>
                            {row}
                          </div>
                        ) : (
                          <div
                            key={index}
                            className={
                              'body-element-block6-title-btn-menu disable'
                            }>
                            {row}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* 배송메세지 입력 */}
                <div className="body-element-block7 mobileoff">
                  <div>
                    <div className="body-element-block7-title">배송메세지</div>
                    <div className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2" }/>
                  </div>
                  <div className="body-element-block7-title-input">
                    <FormItem
                      name="custMessage"
                      value={this.state.custMessage}
                      rules={[
                        {
                          required: false,
                          message: '배송 메세지를 입력해 주세요',
                        },
                      ]}>
                      <TextArea
                        rows={3}
                        cols={110}
                        id="input6"
                        placeholder={'배송 메세지를 입력해 주세요'}
                        onFocus={this.openKeyInputModal2}
                        autoComplete="off"
                      />
                    </FormItem>
                  </div>
                  {
                    (this.state.waiting || this.state.id) ?
                        <div className="body-element-block7-title-blank">&nbsp;</div>
                      :
                        <div className="body-element-block7-title-btn">
                          {this.state.orderCount}회
                          <div className="body-element-block7-title-btn-text">
                            고객주문횟수
                          </div>
                        </div>
                  }

                  <Button
                    className="body-element-block7-title-btn2"
                    onClick={() =>
                      this.formRef.current.setFieldsValue({
                        ...this.formRef.current.getFieldValue(),
                        custMessage: '',
                      })
                    }>
                    메세지삭제
                  </Button>
                </div>

                {/* 배송메세지 입력 - 모바일*/}
                <div className="body-element-block7 mobile">
                  <div className="body-element-block7-title">
                    배송메세지 <span className={skinType === "GOGOIT" ? "gogoit-main-dots2" : "main-dots2"} />
                  </div>
                  {
                    (this.state.waiting || this.state.id) ?
                    <div className="body-element-block7-title-blank">&nbsp;</div>
                    :
                    <div className="body-element-block7-title-btn">
                      {this.state.orderCount}회{' '}
                      <span className="body-element-block7-title-btn-text">
                        고객주문횟수{' '}
                      </span>
                    </div>
                  }

                  <div className="body-element-block7-title-input">
                    <FormItem
                      name="custMessage"
                      rules={[
                        {
                          required: false,
                          message: '배송 메세지를 입력해 주세요',
                        },
                      ]}>
                      <Input
                        id="input6"
                        placeholder={'배송 메세지를 입력해 주세요'}
                        onFocus={this.openKeyInputModal2}
                        autoComplete="off"
                      />
                    </FormItem>
                  </div>
                </div>

                {/* 픽업요청 버튼 */}
                <div className={skinType === "GOGOIT" ? "gogoit-body-element-block8 mobileoff" : "body-element-block8 mobileoff"}>
                  <Button
                    className="body-element-block8-title"
                    type="primary"
                    htmlType="submit">
                    접수요청
                  </Button>
                  <Button
                    className="body-element-block9-title"
                    type="primary"
                    onClick={this.handleAddOrUpdateWaitingOrder}>
                    {this.state.waiting || this.state.id ? `수정` : `대기`}
                  </Button>
                </div>

                <div className={skinType === "GOGOIT" ? "gogoit-body-element-block8 mobile" : "body-element-block8 mobile"}>
                  <Button
                    className="body-element-block9-title"
                    type="primary"
                    htmlType="submit">
                    접수요청
                  </Button>
                  <Button
                    className="body-element-block8-title"
                    type="primary"
                    onClick={this.handleAddOrUpdateWaitingOrder}>
                    {this.state.waiting ? `수정` : `대기`}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        {this.state.addrModalOpen && (
          <AddressModal
            isOpen={this.state.addrModalOpen}
            setAddress={this.setAddress}
            deliveryEnabledDong={this.state.addrDeliveryData}
            close={this.closeAddrModal}
            callback={this.callback}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer, pickupTimeReducer } = state;
  return { loginReducer, posReducer, pickupTimeReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      removePosOrder,
      addWaitingOrder,
      updateWaitingOrder,
      removeWaitingOrder,
      addOrderInfo,
      removeWaitingOrderByOrderAwaitId,
      // updatePickupDelay,
      updateFrom,
      updateManualPickupTimeSetup,
      removeOrderInfoAll,
    },
    dispatch
  );

export default withAlert()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))
);
